var _rect, _text, _rect2, _path, _text2, _rect3, _rect4, _circle, _path2, _text3, _rect5, _path3, _text4, _rect6, _rect7, _circle2, _path4, _text5, _text6, _circle3, _circle4, _circle5, _rect8, _text7, _text8, _rect9, _text9, _text0, _rect0, _circle6, _rect1, _circle7, _path5, _text1, _text10, _rect10, _text11, _text12, _rect11, _rect12, _path6, _circle8, _text13, _rect13, _text14, _text15, _rect14, _circle9, _path7, _text16, _text17, _text18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreDriverWhatsappInterfaceGuidedChatDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 760,
    viewBox: "0 0 900 760",
    role: "img",
    "aria-label": "FleetCore guided WhatsApp workflow desktop interface",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 760,
    rx: 42,
    fill: "#FFFFFF",
    stroke: "#D5E3F2"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 56,
    fill: "#087CFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "DRIVER WORKFLOWS IN ONE FAMILIAR CHAT")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 80,
    width: 190,
    height: 52,
    rx: 15,
    fill: "#087CFF",
    stroke: "#087CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.65 110.4h18.700000000000003v-6.050000000000001l-2.75-4.4h-10.450000000000001l-3.3000000000000003 4.4zM66.95 104.35h12.100000000000001M66.95 110.4v2.75m12.100000000000001-2.75v2.75",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.2100000000000002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 99,
    y: 112,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 800
  }, "Vehicle sign-in")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 80,
    width: 190,
    height: 52,
    rx: 15,
    fill: "#FFFFFF",
    stroke: "#D5E3F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 272.75,
    y: 100.5,
    width: 16.5,
    height: 11.55,
    rx: 2.2,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.2100000000000002
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 106,
    r: 3.3000000000000003,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.2100000000000002
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276.6 100.5l1.6500000000000001-2.75h5.5l1.6500000000000001 2.75",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.2100000000000002,
    strokeLinejoin: "round"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 307,
    y: 112,
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 800
  }, "Vehicle sign-out")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 458,
    y: 80,
    width: 190,
    height: 52,
    rx: 15,
    fill: "#FFFFFF",
    stroke: "#D5E3F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M481.85 113.7v-15.400000000000002h9.9v15.400000000000002M480.2 113.7h13.750000000000002M484.05 101.6h5.5v3.8500000000000005h-5.5zM491.75 101.05l4.4 3.8500000000000005v7.700000000000001c0 2.75 3.8500000000000005 2.75 3.8500000000000005 0v-7.15",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.2100000000000002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 515,
    y: 112,
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 800
  }, "Refuel")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 158,
    width: 812,
    height: 558,
    rx: 30,
    fill: "#E8F0EC",
    stroke: "#C9DAD1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 158,
    width: 812,
    height: 82,
    rx: 20,
    fill: "#075E54"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 199,
    r: 25,
    fill: "#128C7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.25 188.25c-1.5 6 4.5 13.5 10.5 15l3.75-3.75-4.5-3-2.25 2.25c-3-1.5-5.25-3.75-6-6l2.25-2.25-3-4.5z",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.6500000000000001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 193,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 17,
    fontWeight: 850
  }, "FleetCore Controller")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 214,
    fill: "#CFF6E1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "guided sign-in \xB7 FC-217")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 822,
    cy: 189,
    r: 3,
    fill: "#FFFFFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 822,
    cy: 199,
    r: 3,
    fill: "#FFFFFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 822,
    cy: 209,
    r: 3,
    fill: "#FFFFFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 266,
    width: 326,
    height: 81,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#C7D5CD"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 93,
    y: 293,
    fill: "#17251D",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 93,
    dy: 0
  }, "Morning, Thabo."), /*#__PURE__*/React.createElement("tspan", {
    x: 93,
    dy: 22
  }, "Ready to sign in to FC-217?"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 385,
    y: 336,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 9,
    fontWeight: 650
  }, "06:03")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 274,
    width: 190,
    height: 55,
    rx: 16,
    fill: "#D8FDD2",
    stroke: "#C7D5CD"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 645,
    y: 301,
    fill: "#17251D",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 645,
    dy: 0
  }, "Yes, start"))), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 801,
    y: 318,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 9,
    fontWeight: 650
  }, "06:03 \u2713\u2713")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 369,
    width: 420,
    height: 141,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#C7D5CD"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 422,
    r: 29,
    fill: "#E7F3FF"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 111.2,
    y: 414.8,
    width: 21.599999999999998,
    height: 15.12,
    rx: 2.88,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.584
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 422,
    r: 4.32,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.584
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.24 414.8l2.16-3.5999999999999996h7.199999999999999l2.16 3.5999999999999996",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.584,
    strokeLinejoin: "round"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 166,
    y: 403,
    fill: "#17251D",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 850
  }, "Step 1 of 3")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 166,
    y: 430,
    fill: "#385045",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Take the front vehicle photo.")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 450,
    width: 178,
    height: 38,
    rx: 12,
    fill: "#087CFF"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 475,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "Open camera")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 474,
    y: 496,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 9
  }, "06:04")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 562,
    y: 355,
    width: 256,
    height: 160,
    rx: 18,
    fill: "#D8FDD2",
    stroke: "#C7D5CD"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 578,
    y: 371,
    width: 224,
    height: 112,
    rx: 12,
    fill: "#99B9D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M588 469l49-45 34 29 30-21 51 37z",
    fill: "#D5E6F1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 760,
    cy: 391,
    r: 12,
    fill: "#F8D574"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 793,
    y: 502,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 9
  }, "06:05 \u2713\u2713")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 535,
    width: 384,
    height: 91,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#C7D5CD"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 93,
    y: 562,
    fill: "#17251D",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 93,
    dy: 0
  }, "Photo received \u2713"), /*#__PURE__*/React.createElement("tspan", {
    x: 93,
    dy: 22
  }, "Now photograph the dashboard."))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 443,
    y: 615,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 9,
    fontWeight: 650
  }, "06:05")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 538,
    width: 328,
    height: 130,
    rx: 18,
    fill: "#E4FAEE",
    stroke: "#7CE1AC"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 535,
    cy: 603,
    r: 26,
    fill: "#C8F3DC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M528.16 603l4.5600000000000005 4.5600000000000005 9.120000000000001-10.64",
    fill: "none",
    stroke: "#07916D",
    strokeWidth: 2.1279999999999997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 578,
    y: 581,
    fill: "#07916D",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "SIGN-IN COMPLETE")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 578,
    y: 611,
    fill: "#17251D",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 16,
    fontWeight: 850
  }, "FC-217 \xB7 184,263 km")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 578,
    y: 637,
    fill: "#385045",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "Evidence filed automatically")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreDriverWhatsappInterfaceGuidedChatDesktop);
export default __webpack_public_path__ + "static/media/fleetcore-driver-whatsapp-interface-guided-chat-desktop.db75e6639e77b12f0181ea4d3ce91a91.svg";
export { ForwardRef as ReactComponent };